import React from "react";

// reactstrap components
import {
    Alert,
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Modal,
} from "reactstrap";
import CreditCategoryDataService from "../../services/CreditCategoryDataService";

class CreditCategoryModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          defaultModal: false,
          creditCategories: [],
          perPage: 10,
          currentPage: 1,
          currentCreditCategory: {},
        };
        this.creditCategoryDataService = new CreditCategoryDataService();
    }
      
    handleInputChanged(e) {
        let type = e.target.type
        let nam = e.target.name
        let val = type === 'number' ? Number(e.target.value.toString()) : e.target.value
        this.setState(prevState => {
          let currentCreditCategory = Object.assign({}, prevState.currentCreditCategory);
          currentCreditCategory[nam] = val;
          return { currentCreditCategory };
        })
    }

    handleResponse(data, successMessage) {
        if (data.header.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
                return errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.props.toggleModal()
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentCreditCategory: {}})
            this.props.fetchData()
        }
    }
    
    handleAddCreditCategory() {
        this.creditCategoryDataService.add(this.state.currentCreditCategory)
            .then((data) => {
                this.handleResponse(data, "Kategori kredit berhasil ditambahkan");
            })
    }

    handleEditCreditCategory() {
        this.creditCategoryDataService.update(this.state.currentCreditCategory)
            .then((data) => {
                this.handleResponse(data, "Kategori kredit berhasil diubah");
            })
    }

    onKeyUp(e) {
        delete this.state.errorMessage;
        var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        if (charCode === 13) {
            if (this.props.formType === 'edit') {
                this.handleEditCreditCategory();
            } else {
                this.handleAddCreditCategory();
            }
        }
    }

    onModalOpened() {
        this.setCurrentCreditCategory();
    }

    onModalClosed() {
        this.setState({ 
            currentCreditCategory: {},
            errorMessages: [],
         })
    }

    setCurrentCreditCategory() {
        if (this.props.formType === 'edit') {
            this.setState({ currentCreditCategory: this.props.currentCreditCategory })
        }
    }

    render() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.props.formModal}
                toggle={this.props.toggleModal}
                onOpened={this.onModalOpened.bind(this)}
                onClosed={this.onModalClosed.bind(this)}
                >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent">
                        <div className="text-muted text-center mt-2 mb-3">
                            <h3 className="mb-0">{this.props.formType === 'add' ? 'Tambah kategori kredit baru' : 'Ubah kategori kredit' }</h3>
                        </div>
                    </CardHeader>
                    <CardBody className="px-lg-5 py-lg-5">
                        {this.state.errorMessages && this.state.errorMessages.map((errorMessage) => (
                            <Alert color="danger">
                            {errorMessage}
                            </Alert>
                        ))}
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-barcode"
                            >
                                Nama kategori
                            </label>
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                    <i className="ni ni-tag" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Kategori kredit"
                                name="category_name"
                                value={this.state.currentCreditCategory?.category_name}
                                onChange={this.handleInputChanged.bind(this)}
                                onKeyUp={this.onKeyUp.bind(this)}
                                type="text" />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <div className="btn-wrapper text-right">
                            <Button
                                className="my-4"
                                color="secondary"
                                type="button"
                                onClick={this.props.toggleModal}
                                >
                                Batal
                            </Button>
                            <Button
                                className="my-4"
                                color="primary"
                                type="button"
                                onClick={() => this.props.formType === 'add' ? this.handleAddCreditCategory() : this.handleEditCreditCategory()}
                                >
                                Simpan
                            </Button>
                            </div> 
                        </FormGroup> 
                    </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }
}

export default CreditCategoryModal;